/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/button-has-type */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import RoundedButton from './Rounded';

import styles from '../../../styles/buttons/submit.module.scss';

const propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    className: null,
    children: null,
};

const SubmitButton = ({ className, children, ...props }) => (
    <RoundedButton
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
        type="submit"
        {...props}
    >
        {children}
    </RoundedButton>
);

SubmitButton.propTypes = propTypes;
SubmitButton.defaultProps = defaultProps;

export default SubmitButton;
